import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BookWidgetStoreKey } from '../../constants/common.constants';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';

const bookWidgetStoreFeatureSelector =
  createFeatureSelector<BookWidgetStore>(BookWidgetStoreKey);

const getSavedSearchState = createSelector(
  bookWidgetStoreFeatureSelector,
  (state) => state.savedSearch
);

export const getSavedSearchDataList = createSelector(
  getSavedSearchState,
  ({ savedSearchData }) => savedSearchData?.customer?.savedTripList
);

export const isSavedSearchDataReady = createSelector(
  getSavedSearchState,
  (savedSearchData) => savedSearchData.isReady
);
export const isSavedSearchDataErrored = createSelector(
  getSavedSearchState,
  (savedSearchData) => savedSearchData.isError
);
